import { useEffect, useRef, useState } from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import { api } from '../../services/api';

// GIF search for the chat composer: trending until you type, then search
// (debounced). Results come through our API (KLIPY, rated PG).
function GifPicker({ onPick, onClose }) {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const seq = useRef(0);

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, []);

  useEffect(() => {
    const mine = ++seq.current;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const res = await api.searchGifs(q.trim() || undefined);
        if (mine !== seq.current) return;
        setItems(res.items || []);
        setError('');
      } catch (e) {
        if (mine !== seq.current) return;
        setItems([]);
        setError('GIFs aren’t available right now.');
      } finally {
        if (mine === seq.current) setLoading(false);
      }
    }, q ? 350 : 0);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="gif-picker" role="dialog" aria-label="Choose a GIF">
      <div className="gif-picker-head">
        <FiSearch className="gif-picker-search-icon" />
        <input
          ref={inputRef}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Escape' && onClose()}
          placeholder="Search GIFs"
          className="gif-picker-input"
        />
        <button type="button" className="composer-icon-btn" onClick={onClose} title="Close">
          <FiX />
        </button>
      </div>
      <div className="gif-picker-grid">
        {items.map((g) => (
          <button
            key={g.id}
            type="button"
            className="gif-picker-item"
            onClick={() => onPick(g)}
            title={g.title || 'Send this GIF'}
          >
            <img src={g.previewUrl} alt={g.title || 'GIF'} loading="lazy" />
          </button>
        ))}
        {!loading && !items.length && (
          <div className="gif-picker-empty">{error || 'No GIFs found.'}</div>
        )}
      </div>
      <div className="gif-picker-foot">{loading ? 'Loading…' : 'Powered by KLIPY'}</div>
    </div>
  );
}

export default GifPicker;
